// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".location-list[data-v-53b2358a]{width:100%;padding:0 30px}@media(min-width:900px){.location-list[data-v-53b2358a]{padding:15px 70px 0}}@media(max-width:900px){.location-list[data-v-53b2358a]{transform:translateY(-20px)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
